export const environment = {
  production: false,
  api: window['env']['api'] || "https://dev.biogasview.com/client",
  dbHost: window['env']['dbHost'] || 'https://dev.biogasview.com/database'
};
